// @ts-nocheck
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';

import ApplicationBody from '@/components/ApplicationBody';
import StartPageComponent from '@/components/StartPageComponent';
import { DEFAULT_LOCALE } from '@/constants';
import { getLocale } from '@/features/login/selector';
import generateActiveMessages from '@/lib/generateActiveMessages';

export const UnconnectedStartContainer = ({ activeMessages, language, ...rest }) => (
    <ApplicationBody locale={language} activeMessages={activeMessages} hideDriverSidebar>
        <IntlProvider defaultLocale={DEFAULT_LOCALE} locale={language} messages={activeMessages}>
            <StartPageComponent {...rest} />
        </IntlProvider>
    </ApplicationBody>
);

UnconnectedStartContainer.propTypes = {
    activeMessages: PropTypes.object.isRequired,
    language: PropTypes.string.isRequired,
};

const StartContainer = ({ translations, ...rest }) => {
    const locale = useSelector(getLocale);

    return (
        <UnconnectedStartContainer
            {...rest}
            activeMessages={generateActiveMessages(locale, translations)}
            language={locale}
        />
    );
};

export default StartContainer;
